import React from 'react';
import { Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Logo({ className = '', onClick }) {
  return (
    <Link to="/" onClick={onClick} className={`flex items-center gap-2 select-none ${className}`}>
      <span className="relative flex items-center justify-center">
        <Zap className="w-6 h-6 text-[#ff2d2d]" fill="#ff2d2d" strokeWidth={1.5} />
      </span>
      <span className="font-display text-2xl tracking-wide text-white" style={{ transform: 'skewX(-7deg)' }}>
        S-MAN
      </span>
    </Link>
  );
}
